module.exports = __webpack_public_path__ + "static/5-97434bacbf02f3811a76c341c834880a.png";